import VueI18n from 'vue-i18n';
import Vue from 'vue';
import enPrj from '../lang/en.json';
import viPrj from '../lang/vi.json';

Vue.use(VueI18n);
import viLocale from 'element-ui/lib/locale/lang/vi';
import enLocale from 'element-ui/lib/locale/lang/en';

const en = {
  ...enPrj,
  ...enLocale,
}

const vi = {
  ...viPrj,
  ...viLocale,
}
const i18n = new VueI18n({
  locale: 'vi',
  fallbackLocale: 'en',
  messages: {
    vi,
    en,
  },
});

export default i18n;
